import { createSlice } from '@reduxjs/toolkit';
import * as constants from "../../constants/authConstants";

const getExpiresAt = () => {
  const strExpiresAt = window.localStorage.getItem(constants.KEY_TOKEN_EXPIRES_AT);
  if (!strExpiresAt) return null;
  try {
    return new Date(strExpiresAt).toString();
  } catch (e) {
    console.log(`${constants.KEY_TOKEN_EXPIRES_AT} has an invalid value ${strExpiresAt}`);
  }

  return null;
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: window.localStorage.getItem(constants.KEY_TOKEN),
    expiresAt: getExpiresAt(),
    isLoggedIn: false,
    profile: null,
    hasSkillGroupPermission: false,
    hasTeamPermission: false,
    doRedirectLogout: false
  },
  reducers: {
    setAuth(state, action) {
      state.token = action.payload.token;
      state.isLoggedIn = !!action.payload.token;
      state.expiresAt = action.payload.expiresAt;
      state.profile = action.payload.profile;

      console.log("auth - hasSkillGroupPermission:", !!(action.payload.profile 
          && action.payload.profile.authorization 
          && action.payload.profile.authorization.permissions 
          && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("routing:skillgroup:view"))));

      console.log("auth - hasTeamPermission:", !!(action.payload.profile 
            && action.payload.profile.authorization 
            && action.payload.profile.authorization.permissions 
            && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("groups:team:view"))));
  
      state.hasSkillGroupPermission = !!(action.payload.profile 
                                          && action.payload.profile.authorization 
                                          && action.payload.profile.authorization.permissions 
                                          && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("routing:skillgroup:view")));
      
      state.hasTeamPermission = !!(action.payload.profile
                                          && action.payload.profile.authorization 
                                          && action.payload.profile.authorization.permissions 
                                          && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("groups:team:view")));
      state.doRedirectLogout = action.payload.doRedirectLogout;
    },
    setProfile (state, action) {
      console.count("auth-slice: setting profile");
      state.profile = action.payload.profile;

      console.log("auth - hasSkillGroupPermission:", !!(action.payload.profile 
        && action.payload.profile.authorization 
        && action.payload.profile.authorization.permissions 
        && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("routing:skillgroup:view"))));

      console.log("auth - hasTeamPermission:", !!(action.payload.profile 
          && action.payload.profile.authorization 
          && action.payload.profile.authorization.permissions 
          && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("groups:team:view"))));

      state.hasSkillGroupPermission = !!(action.payload.profile 
                                          && action.payload.profile.authorization 
                                          && action.payload.profile.authorization.permissions 
                                          && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("routing:skillgroup:view")));
      state.hasTeamPermission = !!(action.payload.profile
                                          && action.payload.profile.authorization 
                                          && action.payload.profile.authorization.permissions 
                                          && action.payload.profile.authorization.permissions.some(permission => permission.startsWith("groups:team:view")));
    },
    invalidateData(state, action) {
      window.localStorage.removeItem(constants.KEY_TOKEN);
      window.localStorage.removeItem(constants.KEY_TOKEN_EXPIRES_AT);
      window.localStorage.removeItem(constants.KEY_REDIRECT_TO_AFTER_LOGIN);
      
      state.token = null;
      state.expiresAt = null;
      state.isLoggedIn = false;
      state.profile = null;
      state.hasSkillGroupPermission = false;
      state.hasTeamPermission = false;
      state.doRedirectLogout = false;
    }
  },
});

export const authActions = authSlice.actions;

export default authSlice;
